import React from 'react';
import { CaretDownOutlined, LoadingOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import classNames from 'classnames';
import DashboardLink from '../DashboardLink';
import styles from './index.less';
import { track } from '@utils';
import { CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN } from '@src/utils/sensor/track';

const onDropdownItemClick = () => {
  track({
    event: CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN,
  });
};

const renderDropdownItems = (dropdownList: any[] = []) => {
  return [
    {
      type: 'group' as const,
      label: 'Saved Dashboards',
      children: dropdownList.map((item) => ({
        key: item.id?.toString(),
        label: (
          <DashboardLink
            dashboard={item}
            className={classNames({
              [styles.unsaved]: !item.isSaved,
            })}
          />
        ),
      })),
    },
  ];
};

const DashboardDropdown = ({ id = null, className = '', title = '', isFetching, list }: any) => {
  const items = list.filter((item: any) => item.isSaved);

  if (list.length > 0) {
    return (
      <Dropdown
        menu={{ items: renderDropdownItems(items), onClick: onDropdownItemClick }}
        trigger={['click']}
      >
        <span id={id || undefined} className={classNames(className)}>
          {isFetching ? (
            <LoadingOutlined />
          ) : (
            <>
              {title}
              <CaretDownOutlined />
            </>
          )}
        </span>
      </Dropdown>
    );
  }
  return null;
};

export default DashboardDropdown;
